import { useEffect } from 'react';
import { useToast } from '@cad-arc';
import { useApiClient } from './api-client-context';
import {
    attachErrorToastHandler,
    detachResponseInterceptor,
} from './interceptors/response-interceptors';

/**
 * Shows partial-success (207) and bad-request (400) responses from the active api client
 * as toasts.
 *
 * Must be rendered inside `ThemeProvider`: arc's `useToast` themes each toast from the
 * nearest theme context, and a toast created above it renders in light mode — which
 * flips the whole app to light mode while the toast is open.
 */
export function ApiErrorToastInterceptor(): null {
    const apiClient = useApiClient();
    const toast = useToast();

    useEffect(
        function attachErrorToastsToActiveClient() {
            const interceptorId = attachErrorToastHandler(apiClient, toast);
            return () => detachResponseInterceptor(apiClient, interceptorId);
        },
        [apiClient, toast]
    );

    return null;
}
